// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v3.19.1
// source: valve.proto

/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { Filter_ModemIdentifiers, Filter_Modems, Timestamp } from "./base";

export const protobufPackage = "hiber.valve";

export interface Valve {
  /** An 8-character hexadecimal string */
  number: string;
  organization: string;
  externalDeviceId: string;
  name: string;
  deviceType: string;
  /**
   * Valve actuator status: open or closed. Deprecated in favour of status.open
   *
   * @deprecated
   */
  open: boolean;
  leak?: boolean | undefined;
  fraud?: boolean | undefined;
  remainingBatteryVoltage?: number | undefined;
  lastProcess?:
    | Valve_ValveProcess
    | undefined;
  /**
   * The HP line status. Deprecated in favour of status.high_pressure_line.
   *
   * @deprecated
   */
  highPressureLineStatus: Valve_HighPressureLineStatus;
  /** The status of this Valve. */
  status: Valve_Status | undefined;
}

/** @deprecated */
export enum Valve_HighPressureLineStatus {
  /**
   * NOT_PRESSURIZED - High pressure line = 0 bar.
   *
   * @deprecated
   */
  NOT_PRESSURIZED = "NOT_PRESSURIZED",
  /**
   * PRESSURIZED - High pressure line pressurized.
   *
   * @deprecated
   */
  PRESSURIZED = "PRESSURIZED",
  /**
   * READY_TO_BE_PRESSURIZED - High pressure line ready to be pressurized.
   * High pressure line requires manual operation to change status to PRESSURIZED.
   *
   * @deprecated
   */
  READY_TO_BE_PRESSURIZED = "READY_TO_BE_PRESSURIZED",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function valve_HighPressureLineStatusFromJSON(object: any): Valve_HighPressureLineStatus {
  switch (object) {
    case 0:
    case "NOT_PRESSURIZED":
      return Valve_HighPressureLineStatus.NOT_PRESSURIZED;
    case 1:
    case "PRESSURIZED":
      return Valve_HighPressureLineStatus.PRESSURIZED;
    case 2:
    case "READY_TO_BE_PRESSURIZED":
      return Valve_HighPressureLineStatus.READY_TO_BE_PRESSURIZED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Valve_HighPressureLineStatus.UNRECOGNIZED;
  }
}

export function valve_HighPressureLineStatusToNumber(object: Valve_HighPressureLineStatus): number {
  switch (object) {
    case Valve_HighPressureLineStatus.NOT_PRESSURIZED:
      return 0;
    case Valve_HighPressureLineStatus.PRESSURIZED:
      return 1;
    case Valve_HighPressureLineStatus.READY_TO_BE_PRESSURIZED:
      return 2;
    case Valve_HighPressureLineStatus.UNRECOGNIZED:
    default:
      return -1;
  }
}

export enum Valve_Operation {
  /** NO_OPERATION - If no choice is made, fall back to no-operation */
  NO_OPERATION = "NO_OPERATION",
  BLEED_HIGH_PRESSURE_LINE = "BLEED_HIGH_PRESSURE_LINE",
  /**
   * CONFIRM_HIGH_PRESSURE_LINE_IS_ZERO - Confirm high pressure line pressure is 0 bar.
   * High pressure line status can only be updated after operator's confirmation:
   * High pressure line status is confirmed: ZERO
   */
  CONFIRM_HIGH_PRESSURE_LINE_IS_ZERO = "CONFIRM_HIGH_PRESSURE_LINE_IS_ZERO",
  /**
   * RESET_VALVE - Reset valve.
   * Send a downlink command to LoRaWAN LNS to close the valve actuator.
   * High pressure line status should be changed: ZERO -> READY_TO_BE_PRESSURIZED
   */
  RESET_VALVE = "RESET_VALVE",
  /**
   * CONFIRM_VALVE_IS_RESET - Confirm valve is reset.
   * High pressure line status can only be updated after operator's confirmation:
   * High pressure line status is confirmed: READY_TO_BE_PRESSURIZED
   */
  CONFIRM_VALVE_IS_RESET = "CONFIRM_VALVE_IS_RESET",
  /**
   * CONFIRM_HIGH_PRESSURE_LINE_UNDER_PRESSURE - Confirm high pressure line under pressure.
   * The operator is required to manually operate the high pressure line to make it PRESSURIZED
   * High pressure line status can only be updated after operator confirmation:
   * High pressure line status is confirmed: PRESSURIZED
   */
  CONFIRM_HIGH_PRESSURE_LINE_UNDER_PRESSURE = "CONFIRM_HIGH_PRESSURE_LINE_UNDER_PRESSURE",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function valve_OperationFromJSON(object: any): Valve_Operation {
  switch (object) {
    case 0:
    case "NO_OPERATION":
      return Valve_Operation.NO_OPERATION;
    case 1:
    case "BLEED_HIGH_PRESSURE_LINE":
      return Valve_Operation.BLEED_HIGH_PRESSURE_LINE;
    case 2:
    case "CONFIRM_HIGH_PRESSURE_LINE_IS_ZERO":
      return Valve_Operation.CONFIRM_HIGH_PRESSURE_LINE_IS_ZERO;
    case 3:
    case "RESET_VALVE":
      return Valve_Operation.RESET_VALVE;
    case 4:
    case "CONFIRM_VALVE_IS_RESET":
      return Valve_Operation.CONFIRM_VALVE_IS_RESET;
    case 5:
    case "CONFIRM_HIGH_PRESSURE_LINE_UNDER_PRESSURE":
      return Valve_Operation.CONFIRM_HIGH_PRESSURE_LINE_UNDER_PRESSURE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Valve_Operation.UNRECOGNIZED;
  }
}

export function valve_OperationToNumber(object: Valve_Operation): number {
  switch (object) {
    case Valve_Operation.NO_OPERATION:
      return 0;
    case Valve_Operation.BLEED_HIGH_PRESSURE_LINE:
      return 1;
    case Valve_Operation.CONFIRM_HIGH_PRESSURE_LINE_IS_ZERO:
      return 2;
    case Valve_Operation.RESET_VALVE:
      return 3;
    case Valve_Operation.CONFIRM_VALVE_IS_RESET:
      return 4;
    case Valve_Operation.CONFIRM_HIGH_PRESSURE_LINE_UNDER_PRESSURE:
      return 5;
    case Valve_Operation.UNRECOGNIZED:
    default:
      return -1;
  }
}

export interface Valve_Status {
  /** Status of ths valve simplified to a single enum. */
  status: Valve_Status_Combined;
  /** The pressure line status. */
  pressureLine?:
    | Valve_PressureLine_Status
    | undefined;
  /** Valve actuator status. */
  open?:
    | boolean
    | undefined;
  /** The last operations performed on this Valve. */
  lastOperation?:
    | Valve_Operation
    | undefined;
  /** The supported operations at this time. */
  possibleOperations: Valve_Operation[];
  /** The time of the last message from the valve giving us the open state. */
  lastMessageAt:
    | Timestamp
    | undefined;
  /** The time of the last operation. */
  lastOperationAt: Timestamp | undefined;
}

export enum Valve_Status_Combined {
  /**
   * NOT_INITIALIZED - The Valve has not been initialized, status is not known.
   * Actions: Initialize the Valve.
   */
  NOT_INITIALIZED = "NOT_INITIALIZED",
  /**
   * NOT_CONNECTED - The Valve has been initialized, but has not sent a messages.
   * Actions: Wait for the Valve to send a message, contact support if this status persists.
   */
  NOT_CONNECTED = "NOT_CONNECTED",
  /**
   * NOT_VALID - The Valve is not in a valid state.
   * Actions: Please contact support.
   */
  NOT_VALID = "NOT_VALID",
  /**
   * PRESSURIZED - The Valve is closed and the high pressure line is PRESSURIZED.
   * Actions: You can BLEED_HIGH_PRESSURE_LINE to transition to BLEED_REQUESTED.
   */
  PRESSURIZED = "PRESSURIZED",
  /**
   * BLEED_REQUESTED - The Valve is still closed and the high pressure line is PRESSURIZED.
   * Actions: You can BLEED_HIGH_PRESSURE_LINE again or wait.
   */
  BLEED_REQUESTED = "BLEED_REQUESTED",
  /**
   * BLEEDING_PRESSURE - The Valve is open and the high pressure line is bleeding.
   * Actions: You can CONFIRM_HIGH_PRESSURE_LINE_IS_ZERO to transition to DEPRESSURIZED.
   */
  BLEEDING_PRESSURE = "BLEEDING_PRESSURE",
  /**
   * NOT_PRESSURIZED - The Valve is open and the high pressure line is NOT_PRESSURIZED.
   * Actions: You can RESET_VALVE to transition to RESET_REQUESTED.
   */
  NOT_PRESSURIZED = "NOT_PRESSURIZED",
  /**
   * RESET_REQUESTED - The Valve is still open and the high pressure line is NOT_PRESSURIZED.
   * Actions: You can RESET_VALVE again or wait.
   */
  RESET_REQUESTED = "RESET_REQUESTED",
  /**
   * RESETTING - The Valve is closed and the high pressure line is NOT_PRESSURIZED.
   * Actions: You can CONFIRM_VALVE_IS_RESET to transition to RESET.
   */
  RESETTING = "RESETTING",
  /**
   * READY_TO_BE_PRESSURIZED - The Valve is closed and the high pressure line is READY_TO_BE_PRESSURIZED.
   * Actions: You can CONFIRM_HIGH_PRESSURE_LINE_UNDER_PRESSURE to transition back to PRESSURIZED.
   */
  READY_TO_BE_PRESSURIZED = "READY_TO_BE_PRESSURIZED",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function valve_Status_CombinedFromJSON(object: any): Valve_Status_Combined {
  switch (object) {
    case 0:
    case "NOT_INITIALIZED":
      return Valve_Status_Combined.NOT_INITIALIZED;
    case 1:
    case "NOT_CONNECTED":
      return Valve_Status_Combined.NOT_CONNECTED;
    case 2:
    case "NOT_VALID":
      return Valve_Status_Combined.NOT_VALID;
    case 3:
    case "PRESSURIZED":
      return Valve_Status_Combined.PRESSURIZED;
    case 4:
    case "BLEED_REQUESTED":
      return Valve_Status_Combined.BLEED_REQUESTED;
    case 5:
    case "BLEEDING_PRESSURE":
      return Valve_Status_Combined.BLEEDING_PRESSURE;
    case 6:
    case "NOT_PRESSURIZED":
      return Valve_Status_Combined.NOT_PRESSURIZED;
    case 7:
    case "RESET_REQUESTED":
      return Valve_Status_Combined.RESET_REQUESTED;
    case 8:
    case "RESETTING":
      return Valve_Status_Combined.RESETTING;
    case 9:
    case "READY_TO_BE_PRESSURIZED":
      return Valve_Status_Combined.READY_TO_BE_PRESSURIZED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Valve_Status_Combined.UNRECOGNIZED;
  }
}

export function valve_Status_CombinedToNumber(object: Valve_Status_Combined): number {
  switch (object) {
    case Valve_Status_Combined.NOT_INITIALIZED:
      return 0;
    case Valve_Status_Combined.NOT_CONNECTED:
      return 1;
    case Valve_Status_Combined.NOT_VALID:
      return 2;
    case Valve_Status_Combined.PRESSURIZED:
      return 3;
    case Valve_Status_Combined.BLEED_REQUESTED:
      return 4;
    case Valve_Status_Combined.BLEEDING_PRESSURE:
      return 5;
    case Valve_Status_Combined.NOT_PRESSURIZED:
      return 6;
    case Valve_Status_Combined.RESET_REQUESTED:
      return 7;
    case Valve_Status_Combined.RESETTING:
      return 8;
    case Valve_Status_Combined.READY_TO_BE_PRESSURIZED:
      return 9;
    case Valve_Status_Combined.UNRECOGNIZED:
    default:
      return -1;
  }
}

export interface Valve_ValveProcess {
  /** Modem valve actuator number. */
  modemNumber: string;
  /** Operation from technician. */
  operation: Valve_Operation;
  /** Time that the operation was executed. */
  operationAt:
    | Timestamp
    | undefined;
  /**
   * High pressure line status after the operation.
   *
   * @deprecated
   */
  highPressureLineStatus: Valve_HighPressureLineStatus;
  /** Pressure line status after the operation. */
  pressureLineStatus: Valve_PressureLine_Status;
}

export interface Valve_PressureLine {
}

export enum Valve_PressureLine_Status {
  /** NOT_PRESSURIZED - Pressure line = 0 bar. */
  NOT_PRESSURIZED = "NOT_PRESSURIZED",
  /** PRESSURIZED - Pressure line pressurized. */
  PRESSURIZED = "PRESSURIZED",
  /**
   * READY_TO_BE_PRESSURIZED - Pressure line ready to be pressurized.
   * Pressure line requires manual operation to change status to PRESSURIZED.
   */
  READY_TO_BE_PRESSURIZED = "READY_TO_BE_PRESSURIZED",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function valve_PressureLine_StatusFromJSON(object: any): Valve_PressureLine_Status {
  switch (object) {
    case 0:
    case "NOT_PRESSURIZED":
      return Valve_PressureLine_Status.NOT_PRESSURIZED;
    case 1:
    case "PRESSURIZED":
      return Valve_PressureLine_Status.PRESSURIZED;
    case 2:
    case "READY_TO_BE_PRESSURIZED":
      return Valve_PressureLine_Status.READY_TO_BE_PRESSURIZED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Valve_PressureLine_Status.UNRECOGNIZED;
  }
}

export function valve_PressureLine_StatusToNumber(object: Valve_PressureLine_Status): number {
  switch (object) {
    case Valve_PressureLine_Status.NOT_PRESSURIZED:
      return 0;
    case Valve_PressureLine_Status.PRESSURIZED:
      return 1;
    case Valve_PressureLine_Status.READY_TO_BE_PRESSURIZED:
      return 2;
    case Valve_PressureLine_Status.UNRECOGNIZED:
    default:
      return -1;
  }
}

/** Selection object for valve. */
export interface ValveSelection {
  /** Select by valve numbers. */
  numbers?:
    | Filter_Modems
    | undefined;
  /** Select by external device identifiers. */
  identifiers?: Filter_ModemIdentifiers | undefined;
  search?:
    | string
    | undefined;
  /** Select by high pressure line status. */
  status: Valve_Status_Combined[];
  /**
   * Select by high pressure line status.
   *
   * @deprecated
   */
  highPressureLineStatus: Valve_HighPressureLineStatus[];
  /** Select by pressure line status. */
  pressureLineStatus: Valve_PressureLine_Status[];
  /** Select opened valves. */
  onlyOpenedValve?:
    | boolean
    | undefined;
  /** Select closed valves. */
  onlyClosedValve?: boolean | undefined;
}

function createBaseValve(): Valve {
  return {
    number: "",
    organization: "",
    externalDeviceId: "",
    name: "",
    deviceType: "",
    open: false,
    leak: undefined,
    fraud: undefined,
    remainingBatteryVoltage: undefined,
    lastProcess: undefined,
    highPressureLineStatus: Valve_HighPressureLineStatus.NOT_PRESSURIZED,
    status: undefined,
  };
}

export const Valve = {
  encode(message: Valve, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.number !== "") {
      writer.uint32(10).string(message.number);
    }
    if (message.organization !== "") {
      writer.uint32(18).string(message.organization);
    }
    if (message.externalDeviceId !== "") {
      writer.uint32(26).string(message.externalDeviceId);
    }
    if (message.name !== "") {
      writer.uint32(34).string(message.name);
    }
    if (message.deviceType !== "") {
      writer.uint32(42).string(message.deviceType);
    }
    if (message.open !== false) {
      writer.uint32(48).bool(message.open);
    }
    if (message.leak !== undefined) {
      writer.uint32(56).bool(message.leak);
    }
    if (message.fraud !== undefined) {
      writer.uint32(64).bool(message.fraud);
    }
    if (message.remainingBatteryVoltage !== undefined) {
      writer.uint32(72).int64(message.remainingBatteryVoltage);
    }
    if (message.lastProcess !== undefined) {
      Valve_ValveProcess.encode(message.lastProcess, writer.uint32(82).fork()).ldelim();
    }
    if (message.highPressureLineStatus !== Valve_HighPressureLineStatus.NOT_PRESSURIZED) {
      writer.uint32(88).int32(valve_HighPressureLineStatusToNumber(message.highPressureLineStatus));
    }
    if (message.status !== undefined) {
      Valve_Status.encode(message.status, writer.uint32(98).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Valve {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValve();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.number = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.organization = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.externalDeviceId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.name = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.deviceType = reader.string();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.open = reader.bool();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.leak = reader.bool();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.fraud = reader.bool();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.remainingBatteryVoltage = longToNumber(reader.int64() as Long);
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.lastProcess = Valve_ValveProcess.decode(reader, reader.uint32());
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.highPressureLineStatus = valve_HighPressureLineStatusFromJSON(reader.int32());
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.status = Valve_Status.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<Valve>): Valve {
    return Valve.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Valve>): Valve {
    const message = createBaseValve();
    message.number = object.number ?? "";
    message.organization = object.organization ?? "";
    message.externalDeviceId = object.externalDeviceId ?? "";
    message.name = object.name ?? "";
    message.deviceType = object.deviceType ?? "";
    message.open = object.open ?? false;
    message.leak = object.leak ?? undefined;
    message.fraud = object.fraud ?? undefined;
    message.remainingBatteryVoltage = object.remainingBatteryVoltage ?? undefined;
    message.lastProcess = (object.lastProcess !== undefined && object.lastProcess !== null)
      ? Valve_ValveProcess.fromPartial(object.lastProcess)
      : undefined;
    message.highPressureLineStatus = object.highPressureLineStatus ?? Valve_HighPressureLineStatus.NOT_PRESSURIZED;
    message.status = (object.status !== undefined && object.status !== null)
      ? Valve_Status.fromPartial(object.status)
      : undefined;
    return message;
  },
};

function createBaseValve_Status(): Valve_Status {
  return {
    status: Valve_Status_Combined.NOT_INITIALIZED,
    pressureLine: undefined,
    open: undefined,
    lastOperation: undefined,
    possibleOperations: [],
    lastMessageAt: undefined,
    lastOperationAt: undefined,
  };
}

export const Valve_Status = {
  encode(message: Valve_Status, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.status !== Valve_Status_Combined.NOT_INITIALIZED) {
      writer.uint32(8).int32(valve_Status_CombinedToNumber(message.status));
    }
    if (message.pressureLine !== undefined) {
      writer.uint32(16).int32(valve_PressureLine_StatusToNumber(message.pressureLine));
    }
    if (message.open !== undefined) {
      writer.uint32(24).bool(message.open);
    }
    if (message.lastOperation !== undefined) {
      writer.uint32(32).int32(valve_OperationToNumber(message.lastOperation));
    }
    writer.uint32(42).fork();
    for (const v of message.possibleOperations) {
      writer.int32(valve_OperationToNumber(v));
    }
    writer.ldelim();
    if (message.lastMessageAt !== undefined) {
      Timestamp.encode(message.lastMessageAt, writer.uint32(50).fork()).ldelim();
    }
    if (message.lastOperationAt !== undefined) {
      Timestamp.encode(message.lastOperationAt, writer.uint32(58).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Valve_Status {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValve_Status();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.status = valve_Status_CombinedFromJSON(reader.int32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.pressureLine = valve_PressureLine_StatusFromJSON(reader.int32());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.open = reader.bool();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.lastOperation = valve_OperationFromJSON(reader.int32());
          continue;
        case 5:
          if (tag === 40) {
            message.possibleOperations.push(valve_OperationFromJSON(reader.int32()));

            continue;
          }

          if (tag === 42) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.possibleOperations.push(valve_OperationFromJSON(reader.int32()));
            }

            continue;
          }

          break;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.lastMessageAt = Timestamp.decode(reader, reader.uint32());
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.lastOperationAt = Timestamp.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<Valve_Status>): Valve_Status {
    return Valve_Status.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Valve_Status>): Valve_Status {
    const message = createBaseValve_Status();
    message.status = object.status ?? Valve_Status_Combined.NOT_INITIALIZED;
    message.pressureLine = object.pressureLine ?? undefined;
    message.open = object.open ?? undefined;
    message.lastOperation = object.lastOperation ?? undefined;
    message.possibleOperations = object.possibleOperations?.map((e) => e) || [];
    message.lastMessageAt = (object.lastMessageAt !== undefined && object.lastMessageAt !== null)
      ? Timestamp.fromPartial(object.lastMessageAt)
      : undefined;
    message.lastOperationAt = (object.lastOperationAt !== undefined && object.lastOperationAt !== null)
      ? Timestamp.fromPartial(object.lastOperationAt)
      : undefined;
    return message;
  },
};

function createBaseValve_ValveProcess(): Valve_ValveProcess {
  return {
    modemNumber: "",
    operation: Valve_Operation.NO_OPERATION,
    operationAt: undefined,
    highPressureLineStatus: Valve_HighPressureLineStatus.NOT_PRESSURIZED,
    pressureLineStatus: Valve_PressureLine_Status.NOT_PRESSURIZED,
  };
}

export const Valve_ValveProcess = {
  encode(message: Valve_ValveProcess, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.modemNumber !== "") {
      writer.uint32(10).string(message.modemNumber);
    }
    if (message.operation !== Valve_Operation.NO_OPERATION) {
      writer.uint32(16).int32(valve_OperationToNumber(message.operation));
    }
    if (message.operationAt !== undefined) {
      Timestamp.encode(message.operationAt, writer.uint32(26).fork()).ldelim();
    }
    if (message.highPressureLineStatus !== Valve_HighPressureLineStatus.NOT_PRESSURIZED) {
      writer.uint32(32).int32(valve_HighPressureLineStatusToNumber(message.highPressureLineStatus));
    }
    if (message.pressureLineStatus !== Valve_PressureLine_Status.NOT_PRESSURIZED) {
      writer.uint32(40).int32(valve_PressureLine_StatusToNumber(message.pressureLineStatus));
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Valve_ValveProcess {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValve_ValveProcess();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.modemNumber = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.operation = valve_OperationFromJSON(reader.int32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.operationAt = Timestamp.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.highPressureLineStatus = valve_HighPressureLineStatusFromJSON(reader.int32());
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.pressureLineStatus = valve_PressureLine_StatusFromJSON(reader.int32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<Valve_ValveProcess>): Valve_ValveProcess {
    return Valve_ValveProcess.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Valve_ValveProcess>): Valve_ValveProcess {
    const message = createBaseValve_ValveProcess();
    message.modemNumber = object.modemNumber ?? "";
    message.operation = object.operation ?? Valve_Operation.NO_OPERATION;
    message.operationAt = (object.operationAt !== undefined && object.operationAt !== null)
      ? Timestamp.fromPartial(object.operationAt)
      : undefined;
    message.highPressureLineStatus = object.highPressureLineStatus ?? Valve_HighPressureLineStatus.NOT_PRESSURIZED;
    message.pressureLineStatus = object.pressureLineStatus ?? Valve_PressureLine_Status.NOT_PRESSURIZED;
    return message;
  },
};

function createBaseValve_PressureLine(): Valve_PressureLine {
  return {};
}

export const Valve_PressureLine = {
  encode(_: Valve_PressureLine, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Valve_PressureLine {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValve_PressureLine();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<Valve_PressureLine>): Valve_PressureLine {
    return Valve_PressureLine.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<Valve_PressureLine>): Valve_PressureLine {
    const message = createBaseValve_PressureLine();
    return message;
  },
};

function createBaseValveSelection(): ValveSelection {
  return {
    numbers: undefined,
    identifiers: undefined,
    search: undefined,
    status: [],
    highPressureLineStatus: [],
    pressureLineStatus: [],
    onlyOpenedValve: undefined,
    onlyClosedValve: undefined,
  };
}

export const ValveSelection = {
  encode(message: ValveSelection, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.numbers !== undefined) {
      Filter_Modems.encode(message.numbers, writer.uint32(10).fork()).ldelim();
    }
    if (message.identifiers !== undefined) {
      Filter_ModemIdentifiers.encode(message.identifiers, writer.uint32(18).fork()).ldelim();
    }
    if (message.search !== undefined) {
      writer.uint32(26).string(message.search);
    }
    writer.uint32(58).fork();
    for (const v of message.status) {
      writer.int32(valve_Status_CombinedToNumber(v));
    }
    writer.ldelim();
    writer.uint32(34).fork();
    for (const v of message.highPressureLineStatus) {
      writer.int32(valve_HighPressureLineStatusToNumber(v));
    }
    writer.ldelim();
    writer.uint32(66).fork();
    for (const v of message.pressureLineStatus) {
      writer.int32(valve_PressureLine_StatusToNumber(v));
    }
    writer.ldelim();
    if (message.onlyOpenedValve !== undefined) {
      writer.uint32(40).bool(message.onlyOpenedValve);
    }
    if (message.onlyClosedValve !== undefined) {
      writer.uint32(48).bool(message.onlyClosedValve);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ValveSelection {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseValveSelection();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.numbers = Filter_Modems.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.identifiers = Filter_ModemIdentifiers.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.search = reader.string();
          continue;
        case 7:
          if (tag === 56) {
            message.status.push(valve_Status_CombinedFromJSON(reader.int32()));

            continue;
          }

          if (tag === 58) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.status.push(valve_Status_CombinedFromJSON(reader.int32()));
            }

            continue;
          }

          break;
        case 4:
          if (tag === 32) {
            message.highPressureLineStatus.push(valve_HighPressureLineStatusFromJSON(reader.int32()));

            continue;
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.highPressureLineStatus.push(valve_HighPressureLineStatusFromJSON(reader.int32()));
            }

            continue;
          }

          break;
        case 8:
          if (tag === 64) {
            message.pressureLineStatus.push(valve_PressureLine_StatusFromJSON(reader.int32()));

            continue;
          }

          if (tag === 66) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.pressureLineStatus.push(valve_PressureLine_StatusFromJSON(reader.int32()));
            }

            continue;
          }

          break;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.onlyOpenedValve = reader.bool();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.onlyClosedValve = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<ValveSelection>): ValveSelection {
    return ValveSelection.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ValveSelection>): ValveSelection {
    const message = createBaseValveSelection();
    message.numbers = (object.numbers !== undefined && object.numbers !== null)
      ? Filter_Modems.fromPartial(object.numbers)
      : undefined;
    message.identifiers = (object.identifiers !== undefined && object.identifiers !== null)
      ? Filter_ModemIdentifiers.fromPartial(object.identifiers)
      : undefined;
    message.search = object.search ?? undefined;
    message.status = object.status?.map((e) => e) || [];
    message.highPressureLineStatus = object.highPressureLineStatus?.map((e) => e) || [];
    message.pressureLineStatus = object.pressureLineStatus?.map((e) => e) || [];
    message.onlyOpenedValve = object.onlyOpenedValve ?? undefined;
    message.onlyClosedValve = object.onlyClosedValve ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}
